<template>
  <div class = 'program' v-if = "hasPlans">

    <!-- program unit -->
    <!-- <i class = 'fas fa-bookmark'></i>
    <div class = 'connector'> -->

    <i class = 'program-bookmark fa fa-bookmark'></i>
    <div :class = '{"program-line": concentrations.length > 0}'></div>
    <unit v-for="program in programsToShow" :key="program.university_layout_id" :unit = 'program'></unit>

    <!-- concentrations unit -->
    <unit
      class = 'concentration'
      v-for = 'concentration in concentrations'
      :unit = 'concentration'
      :key = 'concentration.id'
    >
    </unit>
  </div>
</template>
<script>
import {ascending} from 'd3'
import Unit from './unit.vue'

export default {
  props: ['program'],

  components: {
    Unit
  },

  computed: {
    inactiveUnit() {
      return {
        inactive: true,
        type: 'program',
        program: this.program.values[0].program
      }
    },
    unit() {
      return this.programs[0] || this.inactiveUnit
    },
    concentrations() {
      return this.program.values
        .filter(v => v.type === 'concentration')
        .sort((a, b) => ascending((a[a.type] || {}).name, (b[b.type] || {}).name))
    },
    programs() {
      return this.program.values
        .filter(v => v.type === 'program')
        .sort((a, b) => ascending((a[a.type] || {}).name, (b[b.type] || {}).name))
    },
    programsWithPlans() {
      return this.programs.filter(p => p.currentPlanPeriod)
    },
    programsToShow() {
      return this.programsWithPlans.length ? this.programsWithPlans : [this.unit]
    },
    hasPlans() {
      return this.showArchived
        ? this.program.values.find(u => u.planPeriods.length)
        : this.program.values.find(u => u.currentPlanPeriod)
    },
    showArchived() {
      return this.$store.state.showArchived
    }
  }
}
</script>



// WEBPACK FOOTER //
// program.vue?197e0371